export const ANIM_RIGHT = "animate__fadeInRight";
export const ANIM_LEFT = "animate__fadeInLeft";
export const ANIM_ROTATE = "animate__rotateIn";
export const ANIM_DOWN = "animate__fadeInUp";

export const ANIM_DOWN_NORMAL = "animate__fadeInDownBig";
